<!--TODO-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      fill="#4f2b1b"
      d="M79.63,42.1c3.25,9.02,2.74,19.12-1.79,27.61-3.83,7.18-10.24,12.95-17.89,15.8-8.03,2.99-17.05,2.89-24.98-.42s-13.81-9.16-17.41-16.55c-4.74-9.72-4.29-21.45,.87-30.9,1.39-2.54-2.49-4.82-3.89-2.27-5.29,9.69-6.32,21.49-2.41,31.86,3.27,8.67,9.61,16.05,17.81,20.43,8.58,4.58,18.79,5.74,28.17,3.17,8.98-2.45,16.83-8.25,21.93-16.01,6.53-9.94,7.95-22.74,3.92-33.91-.41-1.14-1.53-1.91-2.77-1.57-1.1,.3-1.99,1.62-1.57,2.77h0Z"
    />
    <g>
      <rect
        fill="#4f2b1b"
        x="22"
        y="8"
        width="40"
        height="49"
        rx="2.41"
        ry="2.41"
        transform="translate(-8.31 15.51) rotate(-19.07)"
      />
      <rect
        fill="#85c441"
        x="27.31"
        y="15.78"
        width="32"
        height="41"
        transform="translate(-9.48 16.14) rotate(-19.07)"
      />
      <polygon
        fill="#4f2b1b"
        points="56.25 21.69 38 28 40.31 23.55 35.73 21.44 53.98 15.13 56.25 21.69"
      />
    </g>
    <polygon
      fill="#4f2b1b"
      points="57 22 29 49 39 51 59 27 57 22"
    />
    <g>
      <rect
        fill="#4f2b1b"
        x="36.18"
        y="25.71"
        width="57.24"
        height="20.53"
        rx="2.53"
        ry="2.53"
        transform="translate(-6.57 55.96) rotate(-44.68)"
      />
      <path
        fill="#85c441"
        d="M81.32,7.15h1.94c1.4,0,2.53,1.14,2.53,2.53v15.46c0,1.4-1.14,2.53-2.53,2.53h-1.94V7.15h0Z"
        transform="translate(11.9 63.79) rotate(-44.68)"
      />
      <rect
        fill="#85c441"
        x="26.94"
        y="34.85"
        width="57.24"
        height="20.53"
        rx="10.27"
        ry="10.27"
        transform="translate(-15.67 52.11) rotate(-44.68)"
      />
      <g>
        <path
          d="M52.92,51.39l.62-.62-3.64-3.68-.62,.62-1.21-1.23,2.87-2.83,1.21,1.23-.65,.64,3.64,3.68,.65-.64,1.21,1.23-2.87,2.83-1.21-1.23Z"
          fill="#fff"
        />
        <path
          d="M57.29,47.07l.62-.62-3.66-3.7-.5,.49,.64,1.27-.98,.97-2.15-2.17,5.18-5.12,2.15,2.17-.98,.97-1.27-.65-.49,.49,3.66,3.7,.62-.62,1.21,1.23-2.84,2.81-1.21-1.23Z"
          fill="#fff"
        />
        <path
          fill="#fff"
          d="M61.65,42.76l.62-.62-3.64-3.68-.62,.62-1.21-1.23,2.8-2.77,1.21,1.23-.58,.57,1.64,1.66-.2-3.1-.38,.38-1.21-1.23,2.6-2.57,1.21,1.23-.43,.43,.1,3.36,3.66,.21,.59-.58,1.21,1.23-2.87,2.84-1.21-1.23,.42-.41-3.15-.22,1.67,1.69,.58-.57,1.21,1.23-2.8,2.77-1.21-1.23Z"
        />
        <path
          fill="#fff"
          d="M67.88,36.59l.52-.51-2.5-4.81-.61,.6-1.21-1.23,4.32-4.28,1.21,1.23-.6,.59,4.78,2.56,.53-.52,1.21,1.23-2.69,2.66-1.21-1.23,.55-.54-1.07-.58-1.68,1.66,.59,1.06,.54-.53,1.21,1.23-2.69,2.66-1.21-1.23Zm1.91-5.69l-2.52-1.36,1.33,2.53,1.19-1.17Z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          fill="#fff"
          d="M72.04,73.49l-23.62,12.09c-.51,.26-1.11,.26-1.62-.01l-22.87-12.08c-.58-.3-.94-.9-.94-1.55v-23.19c0-.97,.79-1.76,1.76-1.76h46.49c.97,0,1.76,.79,1.76,1.76v23.17c0,.66-.37,1.26-.96,1.56Z"
        />
        <path
          fill="#4f2b1b"
          d="M47.63,87.28c-.52,0-1.05-.13-1.52-.38l-22.87-12.08c-1.07-.56-1.74-1.67-1.74-2.88v-23.19c0-1.79,1.46-3.25,3.25-3.25h46.49c1.79,0,3.25,1.46,3.25,3.25v23.17c0,1.23-.68,2.34-1.77,2.9h0l-23.62,12.1c-.46,.24-.97,.36-1.48,.36ZM24.75,48.5c-.14,0-.25,.11-.25,.25v23.19c0,.09,.05,.18,.14,.23l22.87,12.08c.07,.04,.16,.04,.24,0l23.62-12.09c.09-.04,.14-.13,.14-.23v-23.17c0-.14-.11-.25-.25-.25H24.75Z"
        />
      </g>
      <g>
        <path
          fill="#85c441"
          d="M67.53,56.04c-.83,0-1.5-.67-1.5-1.5v-2.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5v2.5c0,.83-.67,1.5-1.5,1.5Z"
        />
        <path
          fill="#85c441"
          d="M47.71,80.5c-.51,0-1-.12-1.46-.36l-1.14-.6s-.03-.02-.04-.03c-.23-.12-.42-.3-.56-.51h0c-.12-.21-.2-.43-.22-.65l.05-.02h-.05c-.03-.3,.03-.59,.16-.84,.15-.28,.37-.5,.65-.64h0l.02-.02h.02l.09-.04c.4-.16,.86-.13,1.24,.07l1.18,.62s.08,.02,.12,0l1.72-.88c.72-.36,1.65-.06,2.02,.66,.29,.57,.19,1.27-.26,1.73-.12,.12-.25,.21-.39,.28l-1.72,.89c-.44,.22-.93,.34-1.43,.34Zm-6.21-3.07c-.25,0-.48-.06-.7-.17l-4.27-2.26c-.49-.25-.79-.76-.8-1.31,0-.25,.06-.49,.17-.71,.38-.71,1.31-1,2.03-.63l4.27,2.26c.49,.25,.79,.76,.8,1.31,0,.24-.06,.49-.17,.71-.27,.5-.77,.8-1.33,.8Zm12.98-.19c-.57,0-1.08-.31-1.34-.82-.11-.21-.17-.45-.17-.68,0-.57,.32-1.08,.82-1.34l4.3-2.2c.72-.37,1.65-.06,2.02,.65,.1,.21,.16,.45,.16,.68,0,.57-.31,1.08-.82,1.34l-4.29,2.2c-.22,.11-.45,.17-.68,.17Zm-21.52-4.32c-.12,0-.24,0-.36-.04-.03,0-.05-.02-.08-.02-.07-.03-.14-.05-.2-.08h-.02s-.03-.02-.04-.03l-3.62-1.91c-.42-.22-.78-.54-1.06-.92-.2-.26-.3-.58-.29-.9,0-.47,.23-.92,.61-1.2,.65-.47,1.63-.31,2.1,.33,0,.01,.02,.03,.04,.04l3.62,1.91c.49,.25,.79,.76,.8,1.31,0,.24-.06,.49-.18,.71-.26,.5-.76,.8-1.32,.8Zm30.11-.09c-.56,0-1.08-.31-1.34-.81-.1-.21-.16-.44-.16-.68,0-.06,0-.11,.01-.17,.05-.5,.36-.94,.81-1.17l3.57-1.83s.03-.02,.05-.04c.44-.66,1.41-.86,2.08-.4,.41,.28,.66,.74,.66,1.24,0,.3-.09,.59-.26,.84-.3,.44-.7,.79-1.17,1.03l-3.57,1.83c-.21,.11-.44,.16-.68,.16Zm-34.6-7.06c-.82,0-1.5-.67-1.5-1.5v-4.83c0-.83,.68-1.5,1.5-1.5s1.5,.67,1.5,1.5v4.83c0,.83-.67,1.5-1.5,1.5Zm39.06-.08c-.83,0-1.5-.67-1.5-1.49v-4.83c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5v4.83c0,.82-.68,1.49-1.5,1.49Z"
        />
        <path
          fill="#85c441"
          d="M28.47,56.1c-.83,0-1.5-.67-1.5-1.5v-2.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5v2.5c0,.83-.67,1.5-1.5,1.5Z"
        />
      </g>
    </g>
  </svg>
</template>
